import React, { useState, useEffect } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { Zoom, Fullscreen, Slideshow, Share } from "yet-another-react-lightbox/plugins";
import { LazyLoadImage } from 'react-lazy-load-image-component';

const IndiviualImage = ({ data }) => {
    const [images, setImages] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (data && data.length > 0) {
            setImages(data);
            setIsLoading(false);
        } else {
            setIsLoading(false);
        }
    }, [data]);

    const openLightbox = (index) => {
        setCurrentIndex(index);
        setIsOpen(true);
    };

    return (
        <section className="section-property-image">
            <div className="tf-containers">
                {isLoading ? (
                    <p>Loading images...</p>
                ) : images.length > 0 ? (
                    <div className="wrapper-section-gallery d-flex flex-row" style={{ width: "100%" }}>
                        <div className="left-gallery imgwidth1">
                            <div className="image img-1 position-relative" onClick={() => openLightbox(0)}>
                                <LazyLoadImage
                                    alt={images[0]?.title || "Property Image"}
                                    src={images[0]?.src} />
                                {/* <img
                                    className="lazyload"
                                    loading="lazy"
                                    src={images[0]?.src}
                                    alt={images[0]?.title || "Property Image"}
                                    style={{ cursor: "pointer" }}
                                /> */}
                            </div>
                        </div>
                        <div className="right-gallery d-flex flex-column imgwidth1">
                            <div className="right-gallery-section-1">
                                {images[1] && (
                                    <div className="image img-2" onClick={() => openLightbox(1)}>
                                        <LazyLoadImage
                                            alt={images[1]?.title || "Property Image"}
                                            src={images[1]?.src} />
                                        {/* <img className="lazyload" src={images[1]?.src} alt={images[1]?.title || "Property Image"} /> */}
                                    </div>
                                )}
                            </div>
                            <div className="right-gallery-section-2 d-flex flex-row">
                                {images.slice(2, 4).map((img, index) => (
                                    <div key={index} className={`image img-${index + 3}`} onClick={() => openLightbox(index + 2)}>
                                        <LazyLoadImage
                                            alt={img.title || "Property Image"}
                                            src={img.src} />
                                        {/* <img className="lazyload" src={img.src} alt={img.title || "Property Image"} /> */}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ) : (
                    <p>No images available</p>
                )}

                <Lightbox
                    open={isOpen}
                    close={() => setIsOpen(false)}
                    plugins={[Zoom, Fullscreen, Slideshow, Share]}
                    zoom={{ maxZoomPixelRatio: 3 }}
                    slides={images}
                    index={currentIndex}
                />
            </div>
        </section>
    );
};

export default IndiviualImage;
